// extracted by mini-css-extract-plugin
export default {"products":"zC-z","card":"AC-z","oosMessaging":"BC-z"};